import "./ProjectCardStyles.css";
import React from 'react'
import tripadvisor from "../assets/tripadvisor.png"
import sendinblue from "../assets/sendinblue.png"
import mailchamp from "../assets/mailchamp.png"
import glamox from "../assets/glamox.png";


export const ProjectCard = () => {
  return (
    <div className="work-container">
      <h1 className="project-heading"></h1>
      <div className="project-container">

      <div className="project-card">
            <img src={glamox}alt="glamox" />
            <h2 className="project-title" style={{textAlign:"center",textDecoration:"underline"}}>Glamox</h2>
            <div className="pro-details">
              <p>It is an Indian e-commerce company. It sells beauty, wellness and fashion products across websites and mobile apps.</p><br />
              <h3 style={{color:"green",textAlign:"center"}}>Tech Stacks :HTML, CSS, JS, ReactJS, Chakra UI, REST API</h3><br />
              <div className="pro-btns">
                <a href="https://exquisite-tapioca-454087.netlify.app/" className="btn" target={"_blank"} rel="noopener noreferrer">View</a>
                <a href="https://github.com/rajeshdeo/axiomatic-yard-6345" className="btn" target={"_blank"} rel="noopener noreferrer">Source</a>
              </div>
            </div>
        </div>

      <div className="project-card">
            <img src={tripadvisor}alt="tripadvisor" />
            <h2 className="project-title" style={{textAlign:"center",textDecoration:"underline"}}>Tripadvisor</h2>
            <div className="pro-details">
              <p>It is a travel platform. Travellers can book hotels, flights, cruises, book popular tours and attractions, as well as reserve tables at great restaurants.</p><br />
              <h3 style={{color:"green",textAlign:"center"}}>Tech Stacks : ReactJS, Chakra UI, REST API</h3><br />
              <div className="pro-btns">
                <a href="https://jazzy-sunburst-daed46.netlify.app/" className="btn" target={"_blank"} rel="noopener noreferrer">View</a>
                <a href="https://github.com/rajeshdeo/ripe-base-6888" className="btn" target={"_blank"} rel="noopener noreferrer">Source</a>
              </div>
            </div>
        </div>

        <div className="project-card">
            <img src= {sendinblue} alt="pro1" />
            <h2 className="project-title" style={{textAlign:"center",textDecoration:"underline"}}>Sendinblue</h2>
            <div className="pro-details">
              <p>Sendinblue is a digital marketing platform 
                empowering B2B and B2C businesses, ecommerce sellers and agencies to build 
                customer relationships.</p><br />
              <h3 style={{color:"green",textAlign:"center"}}>Tech Stacks : HTML, CSS, JavaScript (ES5) </h3><br />
              <div className="pro-btns">
                <a href="https://stellar-sherbet-64792c.netlify.app/" className="btn" target={"_blank"} rel="noopener noreferrer">View</a>
                <a href="https://github.com/rajeshdeo/bouncy-day-6431" className="btn" target={"_blank"} rel="noopener noreferrer">Source</a>
              </div>
            </div>
        </div>



        <div className="project-card">
            <img src={mailchamp}alt="mailchamp" />
            <h2 className="project-title" style={{textAlign:"center",textDecoration:"underline"}}>Mailchamp</h2>
            <div className="pro-details">
              <p>Mailchamp is a marketing automation platform and email marketing service.</p><br />
              <h3 style={{color:"green",textAlign:"center"}}>Tech Stacks : HTML, CSS, JavaScript (ES5) </h3><br />
              <div className="pro-btns">
                <a href="https://mailchamp.netlify.app/" className="btn" target={"_blank"} rel="noopener noreferrer">View</a>
                <a href="https://github.com/rajeshdeo/offbeat-need-8210" className="btn" target={"_blank"} rel="noopener noreferrer">Source</a>
              </div>
            </div>
        </div>

        
      </div>
    </div>
  )
}
